import type { Agent, Task, TaskType } from "./domain";

export type TaskBusiness = "promotion" | "sms";
export type Business = TaskBusiness | "advertising";
export const taskBusinesses: TaskBusiness[] = ["promotion", "sms"];
export const businessLabels: Record<Business, string> = { promotion: "App推广", sms: "iMessage", advertising: "发布广告" };
const promotionTypes: TaskType[] = ["normal", "download", "other_normal"];
export const taskBusiness = (type: TaskType): TaskBusiness => type === "message_send" ? "sms" : "promotion";
/** Execution links follow the published task; editing follows the current draft. */
export function taskRouteBusiness(task: Pick<Task, "business" | "execution_business" | "payload">, destination?: string): TaskBusiness {
  const execution = destination === "/reports" || destination === "/submissions";
  const explicit = execution ? task.execution_business ?? task.business : task.business;
  return explicit === "promotion" || explicit === "sms" ? explicit : taskBusiness(task.payload.task_type);
}
export function businessTaskTypes(agent: Pick<Agent, "allowed_task_types">, business: TaskBusiness): TaskType[] {
  return (agent.allowed_task_types ?? []).filter((type) => business === "sms" ? type === "message_send" : promotionTypes.includes(type));
}
export function hasBusinessAccess(agent: Agent, business: Business): boolean {
  return business === "advertising"
    ? agent.advertising_enabled === true
    : businessTaskTypes(agent, business).length > 0;
}
export const taskBasePath = (business: TaskBusiness) => `/${business}/tasks`;
export const taskPath = (business: TaskBusiness, id?: string | number, edit = false) => `${taskBasePath(business)}${id == null ? "" : `/${id}${edit ? "/edit" : ""}`}`;
export const firstTaskBusiness = (agent: Agent) => taskBusinesses.find((business) => hasBusinessAccess(agent, business));
export function defaultBusinessPath(agent: Agent): string {
  const business = firstTaskBusiness(agent);
  return business ? taskBasePath(business) : hasBusinessAccess(agent, "advertising") ? "/advertising" : "/";
}
export function businessFromPath(path: string): Business | undefined {
  return (["promotion", "sms", "advertising"] as const).find((business) => path === `/${business}` || path.startsWith(`/${business}/`));
}
export function canAccessBusinessPath(agent: Agent, path: string): boolean {
  const business = businessFromPath(path);
  return !business || hasBusinessAccess(agent, business);
}
